import { render } from "./Technologies.vue?vue&type=template&id=480aace2"
import script from "./Technologies.vue?vue&type=script&lang=js"
export * from "./Technologies.vue?vue&type=script&lang=js"

import "./Technologies.vue?vue&type=style&index=0&id=480aace2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__